import script from "./PublicMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicMessages.vue?vue&type=script&setup=true&lang=js"

import "./PublicMessages.vue?vue&type=style&index=0&id=419f9cb1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-419f9cb1"]])

export default __exports__